import {
  typographySx
} from "./chunk-6XKRCO5F.mjs";
import {
  omitHTMLProps,
  omitStyleProps
} from "./chunk-XIOYLRBK.mjs";
import {
  bodySizesSx
} from "./chunk-INKIBRAZ.mjs";

// src/components/Body/Body.tsx
import { cloneElement, isValidElement, memo } from "react";
import { callAllFn } from "@julo-ui/function-utils";
import { cx, forwardRef, julo } from "@julo-ui/system";
import { jsx } from "react/jsx-runtime";
var Body = forwardRef((props, ref) => {
  const {
    asChild,
    children,
    className,
    onClick,
    size = "regular",
    bold = false,
    sx,
    ...resProps
  } = props;
  const styleProps = omitHTMLProps(resProps);
  const htmlProps = omitStyleProps(resProps);
  if (asChild) {
    if (!isValidElement(children))
      throw new Error("Please render an element");
    const { props: childProps } = children;
    return cloneElement(children, {
      ...htmlProps,
      ...childProps,
      className: cx(className, childProps == null ? void 0 : childProps.className),
      onClick: callAllFn(onClick, childProps == null ? void 0 : childProps.onClick),
      sx: {
        ...bodySizesSx[size],
        ...styleProps,
        ...typographySx({ fontWeight: styleProps.fontWeight, bold }),
        ...sx,
        ...childProps.sx
      }
    });
  }
  return /* @__PURE__ */ jsx(
    julo.p,
    {
      ref,
      className,
      onClick,
      sx: {
        ...bodySizesSx[size],
        ...styleProps,
        ...typographySx({ fontWeight: styleProps.fontWeight, bold }),
        ...sx
      },
      ...htmlProps,
      children
    }
  );
});
var Body_default = memo(Body);

export {
  Body_default
};
